import styled, { DefaultTheme } from 'styled-components';
import Text from 'src/styles/Themes/Text';
import Screen from 'src/styles/Themes/Screen';
import Palette from '@/styles/Themes/Palette';
import { DropdownArrow } from '@/shared/images/icons/DropdownArrow';
import { Transition } from '@/styles/Themes/KeyFrames';

export const Container = styled.div`
    padding-bottom: 12px;

    ${Screen.desktop} {
        margin-bottom: 64px;
    }
`;

export const Title = styled.h3`
    color: ${Palette.white.normal};
    ${Text.Full.large.semibold}
    cursor: pointer;
    padding: 24px 0 12px;
    margin: 0;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid ${Palette.dark.dark2};

    ${Screen.ipad} {
    }
    ${Screen.desktop} {
        border-top: none;
        cursor: auto;
        padding: 0 0 12px;
    }
`;

interface IWithIsActive extends DefaultTheme {
    isActive: boolean;
}

export const Arrow = styled(DropdownArrow)<IWithIsActive>`
    ${({ isActive }) => isActive && 'transform: rotate(-180deg);'}
    ${Transition.arrow}
    ${Screen.desktop} {
        display: none;
    }
`;

export const Item = styled.a`
    color: ${Palette.white.normal};
    ${Text.Full.large.regular}
    display: block;

    &:hover {
        color: ${Palette.green.normal};
        ${Transition.normal}
    }

    margin: 13px 0;

    position: relative;
    animation-duration: 0.3s;
    animation-name: slidein;
    animation-timing-function: ease;

    ${Screen.ipad} {
    }
    ${Screen.desktop} {
        margin: 4px 0;
    }
`;
